module.exports = __webpack_public_path__ + "img/parkingrecord.00983b21.png";